import { render, staticRenderFns } from "./SimulacaoEdit.vue?vue&type=template&id=c2a1044c"
import script from "./SimulacaoEdit.vue?vue&type=script&lang=js"
export * from "./SimulacaoEdit.vue?vue&type=script&lang=js"
import style0 from "./SimulacaoEdit.vue?vue&type=style&index=0&id=c2a1044c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports